import { SET_TICKER_LOT_SIZE, SET_SYMBOL_TICKERS } from './action'

const initialState = {
  tickerSize: {},
  lotSize: {},
  symbolTickers: [],
}

const setTickerLotSize = (state, action) => {
  const tickerSize = {}
  const lotSize = {}
  const {
    data: { pairs },
  } = action
  if (Array.isArray(pairs)) {
    pairs.forEach(pair => {
      const symbol = `${pair.base_asset_symbol}_${pair.quote_asset_symbol}`
      tickerSize[symbol] = pair.tick_size
      lotSize[symbol] = pair.lot_size
    })
  }
  return {
    ...state,
    tickerSize,
    lotSize,
  }
}

const setSymbolTickers = (state, action) => {
  const {
    data: { from },
  } = action
  const {
    data: { symbolTickers },
  } = action
  if (!Array.isArray(symbolTickers)) return state

  if (from === 'rest') {
    return {
      ...state,
      symbolTickers: symbolTickers.map(s => ({
        symbol: s.symbol,
        priceChangePercent: s.priceChangePercent / 100,
        baseAssetVolume: s.volume,
        quoteVolume: s.quoteVolume,
        volume: Number(s.quoteVolume),
        price: s.lastPrice,
        highPrice: s.highPrice,
        lowPrice: s.lowPrice,
      })),
    }
  }

  if (from === 'ws') {
    return {
      ...state,
      symbolTickers,
    }
  }

  return state
}

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_TICKER_LOT_SIZE:
      return setTickerLotSize(state, action)

    case SET_SYMBOL_TICKERS:
      return setSymbolTickers(state, action)

    default:
      return state
  }
}
